"use client"
import React from "react"

const Analytics: React.FC = () => {
  return (
    <div className="w-full h-full p-4">
      <h1 className="text-2xl font-semibold mb-4">
        Análisis General - <span className="font-bold">Looker Studio</span>
        </h1>

      <div className="w-full h-[calc(100vh-100px)] rounded-xl overflow-hidden shadow-md">
        <iframe
            title="Reporte Looker Studio"
            src="https://lookerstudio.google.com/embed/reporting/22369fb5-fcfc-4dc1-a0b0-1d8bf83c3194/page/7mNHF"
            className="w-full h-full border-0"
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </div>
  )
}

export default Analytics
